import React from 'react';
import style from '../QuantQual.module.css';
import { LEGEND_COLORS } from '../../../reports-constants';
import HeroCard from '../../../../../components/HeroCard/HeroCard';

const transformDataToHeroCard = (subUnitHighlights) => {
  const heroTitle = 'Subunit Highlights';
  const modalContent = (
    <div>
      <p><b>Assignments in this Subunit</b> represents the total number of resources (readings, activities, assessments) assigned to your students in this Subunit.</p>
      <p><b>Students completed % of assignments</b> represents the proportion of assignments in this Subunit completed across all students in your class.</p>
      <p><b>Students answered % of questions correctly on first try</b> represents, across all questions in this Subunit answered by all students in your class, the proportion that were correct on a student&#39;s first try.</p>
    </div>
  );
  const assignmentsIsSingular = (subUnitHighlights.assignments === 1);
  const modalTitle = 'Subunit Highlights';
  const heroData = [
    {
      title: `There ${assignmentsIsSingular ? 'is' : 'are'}`,
      text: subUnitHighlights.assignments >= 0 ? subUnitHighlights.assignments : 0,
      color: LEGEND_COLORS.BLACK,
      showBottomText: true,
      bottomText: `${assignmentsIsSingular ? 'Assignment' : 'Assignments'} in this Subunit`,
    },
    {
      title: 'Students Completed',
      color: LEGEND_COLORS.BLACK,
      text: subUnitHighlights.completedAssignmentsPercentage === -1 ? '—' : `${Math.round(subUnitHighlights.completedAssignmentsPercentage * 100)}%`,
      isAverage: false,
      showBottomText: true,
      bottomText: 'of Assignments',
    },
    {
      title: 'Students Answered',
      color: LEGEND_COLORS.BLACK,
      text: subUnitHighlights.correctOnFirstTry === -1 ? '—' : `${Math.round(subUnitHighlights.correctOnFirstTry * 100)}%`,
      isAverage: false,
      showBottomText: true,
      bottomText: 'of Questions Correctly On Their First Try',
    },
  ];
  return {
    heroData,
    heroTitle,
    modalTitle,
    modalContent,
  };
};

const subUnitHighlightsComponent = (subUnitHighlights) => {
  const {
    heroData,
    heroTitle,
    modalTitle,
    modalContent,
  } = transformDataToHeroCard(subUnitHighlights);
  return (
    <HeroCard
      className={style.qqReportCard}
      heroData={heroData}
      heroTitle={heroTitle}
      modalTitle={modalTitle}
      modalContent={modalContent}
      showNullStateMessage={false}
    />
  );
};

export default subUnitHighlightsComponent;
